import { watch, onBeforeUnmount } from 'vue';
import { useEventListener } from '@vueuse/core';
import { useAccount } from './useAccount';
import { useStore } from './store';
import { applyAppearanceTheme } from 'dashboard/helper/appearanceTheme';

export const useAppearanceTheme = () => {
  const { accountId, currentAccount } = useAccount();
  const store = useStore();
  let restore = () => {};

  watch(
    () => currentAccount.value.appearance_theme,
    theme => {
      restore();
      restore = applyAppearanceTheme(document.documentElement, theme);
    },
    { immediate: true, deep: true }
  );

  const stopFocusListener = useEventListener(window, 'focus', () => {
    if (accountId.value) {
      store.dispatch('accounts/get', {
        accountId: accountId.value,
        silent: true,
      });
    }
  });
  onBeforeUnmount(() => {
    stopFocusListener();
    restore();
  });
};
